import { Col, Navbar } from 'react-bootstrap';
import Header, { HeaderNav, Menu } from '../../../Components/Header/Header';
import { Link, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getEOITenders } from '../../../Store/Publication/eoiTenders';
import { useEffect, useRef, useState } from 'react';

const HeaderKera = () => {
	const { pathname } = useLocation();
	const [expanded, setExpanded] = useState(false); // Add state for navbar toggle
	
	const headerData = [
		{
			title: 'About',
			dropdown: [
				{
					link: 'about_us',
					title: 'About Us',
				},
				{
					link: 'leadership',
					title: 'Leadership',
				},
				{
					link: 'team',
					title: 'Team',
				},
			],
		},
		{
			link: 'beneficiary-corner',
			title: 'Beneficiary Corner',
		},
		// {
		//   link: "publication",
		//   title: "Publications",
		// },

		{
			title: 'Document Repository',
			dropdown: [
				{
					link: 'document-repository/project-appraisal-document',
					title: 'Project Appraisal Document',
				},
				{
					link: 'document-repository/meeting-minutes',
					title: 'Meeting Minutes',
				},
				{
					link: 'document-repository/project-documents',
					title: 'Project Documents',
				},
				{
					link: 'document-repository/reports',
					title: 'Reports',
				},
			],
		},
		{
			title: 'Gallery',
			dropdown: [
				{
					link: 'photo-gallery',
					title: 'Photo Gallery',
				},
				{
					link: 'video-gallery',
					title: 'Video Gallery',
				},
				{
					link: 'kera-in-media',
					title: 'kera in Media',
				},
			],
		},
		{
			link: 'notifications',
			title: 'Notifications',
		},
		// {
		//   link: 'rti',
		//   title: 'RTI'
		// },
		{
			link: 'contact',
			title: 'Contact us',
		},
	];

	const { data: EOITendersData } = useQuery({
		queryKey: ['EOITendersData', 0],
		queryFn: () => getEOITenders(0),
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	});

	const contentRef = useRef(null);
	const [duration, setDuration] = useState(20); // default 20s

	useEffect(() => {
		if (contentRef.current) {
			const contentWidth = contentRef.current.scrollWidth;

			// base speed: ~100px/sec
			const seconds = Math.max(40, contentWidth / 100);

			setDuration(seconds);
		}
	}, [EOITendersData]);

	// Close navbar when pathname changes (page navigation)
	useEffect(() => {
		setExpanded(false);
	}, [pathname]);

	// Function to close navbar when a link is clicked (for mobile)
	const handleNavItemClick = () => {
		setExpanded(false);
	};

	return (
		<>
			<Header topSpace={{ desktop: true }} type="reverse-scroll">
				<HeaderNav
					fluid="fluid"
					theme="light"
					bg="white"
					menu="light"
					containerClass="sm:px-0"
					className="px-[35px] py-[0px] md:pr-[15px] md:pl-0"
				>
					<Col sm={6} lg={2} xs="auto" className="me-auto ps-0">
						<Link 
							aria-label="logo home" 
							className="flex items-center" 
							to="/"
							onClick={handleNavItemClick} // Close navbar when logo is clicked
						>
							<Navbar.Brand className="inline-block m-0">
								<img
									className="default-logo"
									width="110"
									height="36"
									loading="lazy"
									src="/images/full logo.webp"
									data-rjs="/images/full logo.webp"
									alt="logo"
								/>
								<img
									className="alt-logo"
									width="110"
									height="36"
									loading="lazy"
									src="/images/full logo.webp"
									data-rjs="/images/full logo.webp"
									alt="logo"
								/>
								<img
									className="mobile-logo"
									width="110"
									height="36"
									loading="lazy"
									src="/images/full logo.webp"
									data-rjs="/images/full logo.webp"
									alt="logo"
								/>
							</Navbar.Brand>
						</Link>
					</Col>
					<Navbar.Toggle 
						className="order-last md:ml-[17px] md:px-[15px]"
						onClick={() => setExpanded(!expanded)} // Toggle expanded state
						aria-expanded={expanded}
					>
						<span className="navbar-toggler-line"></span>
						<span className="navbar-toggler-line"></span>
						<span className="navbar-toggler-line"></span>
						<span className="navbar-toggler-line"></span>
					</Navbar.Toggle>
					<Navbar.Collapse 
						className="col-auto justify-center menu-order finance-header-menu px-lg-0 col-lg-8"
						in={expanded} // Control collapse state
					>
						<Menu 
							data={headerData} 
							onItemClick={handleNavItemClick} // Pass click handler to Menu
						/>
					</Navbar.Collapse>
					<Col xs="auto" lg={2} className="text-right pe-0">
						<Link 
							to="/" 
							onClick={handleNavItemClick} // Close navbar when govt logo is clicked
						>
							<Navbar.Brand className="inline-block p-3 m-0">
								<img
									className="default-logo"
									width="200"
									height="50"
									loading="lazy"
									src="/images/govtLogo.png"
									data-rjs="/images/govtLogo.png"
									alt="logo"
								/>
								<img
									className="alt-logo"
									width="200"
									height="50"
									loading="lazy"
									src="/images/govtLogo.png"
									data-rjs="/images/govtLogo.png"
									alt="logo"
								/>
								<img
									className="mobile-logo"
									width="200"
									height="50"
									loading="lazy"
									src="/images/govtLogo.png"
									data-rjs="/images/govtLogo.png"
									alt="logo"
								/>
							</Navbar.Brand>
						</Link>
					</Col>
				</HeaderNav>

				{pathname === '/' && (
					<div className="w-full bg-[#005b85] py-[3px] text-white leading-4 cursor-pointer overflow-hidden">
						<div className="marquee">
							<div
								className="marquee-content"
								ref={el => (contentRef.current = el)}
								style={{
									animationDuration: `${duration}s`, // dynamic speed
								}}
							>
								{EOITendersData?.data?.length > 0 ? (
									<>
										{/* Extra static links */}
										<span className="mr-[40px] inline-block">
											<a
												href="https://www.keraplantation.kerala.gov.in/public/index.php/training_registration?scheme_id=MTg="
												target="_blank"
												rel="noopener noreferrer"
											>
												Rubber Replantation Scheme: Register for Training
											</a>
										</span>

										<span className="mr-[40px] inline-block">
											<a
												href="https://pa.kera.kerala.gov.in/"
												target="_blank"
												rel="noopener noreferrer"
											>
												Productive Alliances Scheme: Call for Applications
											</a>
										</span>
										<span className="mr-[40px] inline-block">
											<a
												href="https://agrinext.startupmission.in/"
												target="_blank"
												rel="noopener noreferrer"
											>
												AgriNext - Startup Component
											</a>
										</span>
										<span className="mr-[40px] inline-block">
											<a
												href="https://etenders.kerala.gov.in/"
												target="_blank"
												rel="noopener noreferrer"
											>
												Tender Notice: TSA Productive Alliances
											</a>
										</span>
									</>
								) : (
									'Welcome to KERA'
								)}
							</div>
						</div>
					</div>
				)}
			</Header>
		</>
	);
};

export default HeaderKera;